import React, { useState } from "react"
import * as graphql from "lib/types/generated/graphql-types"
import FailedOrderLineModifications from "./FailedOrderLineModifications"
import { Container } from "../../../../../views/Orders/ManageOrder/ManageOrder.styled"
import { OrderSummary } from "./OrderSummary/OrderSummary"
import { Cart } from "./Cart/Cart"
import StatusPopup from "./Cart/StatusPopup"
import PendingOrderLineModification from "./PendingOrderLineModification"
import AddOrUpdateOrderLineSideBar from "./EditOrderLine/AddOrUpdateOrderLineSideBar"
import ModificationAction from "./Cart/ModificationAction"
import { ModificationOrderLines } from "../../../../../classes/order/ModificationOrderLines"
import {
  CustomReasonCode,
  OrderModificationOrderLines,
  Reason
} from "lib/types/generated/graphql-types"
import { ReasonType } from "lib/types/order"

type Props = {
  order: graphql.Order
  refetch: () => void
  loading: boolean
  orderHistory: graphql.OrderHistory
  customReasons: CustomReasonCode[]
}

const ModifyOrderLines = ({ order, refetch, loading, orderHistory , customReasons}: Props) => {
  const [showConfirmation, setShowConfirmation] = useState(false)
  const [showStatusPopup, setShowStatusPopup] = useState(false)
  const [startedModification, setStartedModification] = useState("")
  const [productVariant, setProductVariant] = useState<graphql.ProductVariant>()
  const [editOrderLine, setEditOrderLine] = useState<graphql.OrderLine | undefined>()
  const [paymentAction, setPaymentAction] =
    useState<graphql.InputActionPaymentOrderModificationOrderLines>({
      actionType: graphql.InputActionType.Auto
    })
  const [reason, setReason] = useState<Reason>({code: "", cause: ""})
  const [reasonType, setReasonType] = useState<ReasonType | undefined>()
  const modificationOrderLines = new ModificationOrderLines(order.Modifications as OrderModificationOrderLines[])

  if (modificationOrderLines.pending() && !showStatusPopup)
    return (
      <PendingOrderLineModification
        pendingModification={modificationOrderLines.getPendingModification()}
        orderRefetch={refetch}
        orderLoading={loading}
      />
    )

  return (
    <>
      {showStatusPopup && startedModification && (
        <StatusPopup
          setShowStatusPopup={setShowStatusPopup}
          modificationId={startedModification}
          refetchOrder={refetch}
        />
      )}
      {modificationOrderLines.failed() ? (
        modificationOrderLines
          .failedModifications()
          .map((modification: graphql.OrderModification) => (
            <FailedOrderLineModifications
              key={modification.id}
              failedModification={modification}
              currencyCode={order.currencyCode}
              setShowStatusPopup={setShowStatusPopup}
              setStartedModification={setStartedModification}
              orderHistory={orderHistory.history}
              refetch={refetch}
            />
          ))
      ) : !showConfirmation && order ? (
        <Container>
          <AddOrUpdateOrderLineSideBar
            productVariant={productVariant}
            setProductVariant={setProductVariant}
            storeGroupId={order?.storeGroupId}
            countryCode={order.countryCode}
            currencyCode={order.currencyCode}
            order={order}
            refetch={refetch}
            editOrderLine={editOrderLine}
            setEditOrderLine={setEditOrderLine}
            reason={reason}
          />
          <div>
            <OrderSummary
              customReasons={customReasons}
              order={order}
              refetch={refetch}
              orderLoading={loading}
              editOrderLine={editOrderLine}
              setEditOrderLine={setEditOrderLine}
              setProductVariant={setProductVariant}
              reason={reason}
              setReason={setReason}
              reasonType={reasonType}
              setReasonType={setReasonType}
            />
          </div>
          <div>
            <Cart
              order={order}
              refetch={refetch}
              setShowConfirmation={setShowConfirmation}
              orderLoading={loading}
            />
          </div>
        </Container>
      ) : (
        <Container>
          <div>
            <Cart
              order={order}
              refetch={refetch}
              setShowConfirmation={setShowConfirmation}
              summaryMode={true}
              orderLoading={loading}
            />
          </div>
          <div>
            {modificationOrderLines
              .onGoingModifications()
              ?.map((modification) => (
                <ModificationAction
                  key={modification.id}
                  modification={modification}
                  paymentAction={paymentAction}
                  setPaymentAction={setPaymentAction}
                  orderId={order.id}
                  setShowStatusPopup={setShowStatusPopup}
                  setStartedModification={setStartedModification}
                  setShowConfirmation={setShowConfirmation}
                />
              ))}
          </div>
        </Container>
      )}
    </>
  )
}

export default ModifyOrderLines
